import React from "react";
import { useQuery } from "../../hooks/useQuery";
import { api } from "../../lib/api";
import { Loader2 } from "lucide-react";

export default function Audit() {
  const { data, loading } = useQuery(() => api.get("/audit-log").then((r) => r.data));

  return (
    <div data-testid="audit-page">
      <h1 className="font-serif-bv text-3xl text-[#1B3022]">Audit Log</h1>
      <p className="text-sm text-[#1B3022]/60 mb-6">Immutable record of all administrative actions — Who, What, When.</p>

      <div className="bg-white border border-[#1B3022]/15 rounded-sm overflow-hidden">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-[#0F1D14] text-[#D4AF37]">
            <tr>
              {["When", "Who", "Action", "Target", "Details"].map((h) => <th key={h} className="px-3 py-3 text-left text-[10px] tracking-widest uppercase font-medium">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#1B3022]/60"><Loader2 className="inline animate-spin" /></td></tr>}
            {!loading && (data || []).length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#1B3022]/60">No entries.</td></tr>}
            {(data || []).map((e) => (
              <tr key={e.id} className="border-t border-[#1B3022]/10 hover:bg-[#F5EFE0]/40">
                <td className="px-3 py-2 text-[#1B3022]/70 text-xs">{new Date(e.timestamp).toLocaleString()}</td>
                <td className="px-3 py-2">
                  <div className="text-[#1B3022] text-xs">{e.actor_email}</div>
                  <div className="text-[10px] uppercase tracking-widest text-[#A88420]">{e.actor_role}</div>
                </td>
                <td className="px-3 py-2"><span className="font-mono text-xs bg-[#D4AF37]/15 px-2 py-0.5 rounded-sm">{e.action}</span></td>
                <td className="px-3 py-2 text-[#1B3022]/85 text-xs">{e.target}</td>
                <td className="px-3 py-2 text-[10px] text-[#1B3022]/60 font-mono">{JSON.stringify(e.details)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
